import './MGMySubscriptions.css'
import { MGMySubscriptionDetailCardType } from './MGMySubscriptionDetailCardType'
import MGMySubscriptionDetailCard from './MGMySubscriptionDetailCard';

//COMPONENT


export default function MGMySubscriptions(
    {
        mySubscriptions,
        subscriptionDetailCardType = MGMySubscriptionDetailCardType.SAVING | MGMySubscriptionDetailCardType.PROTECTION | MGMySubscriptionDetailCardType.SAVING_PLUS_PROTECTION
    }
) {

    return (
        <div className='MGMySubscriptions-container'>
            <h4>As minhas subscrições</h4>
            <div className="MGMySubscriptions-card-list">
                {mySubscriptions.map((item) => (
                    <div>
                        <MGMySubscriptionDetailCard
                            subscriptionNumber={item.subscriptionNumber}
                            subscriptionID={item.subscriptionID}
                            subscriptionDate={item.subscriptionDate}
                            canReapply={item.canReapply}
                            canReinforce={item.canReinforce}
                            rightAmount={item?.receivedAmount | item?.paidAmount}
                            leftAmount={item?.investedAmount | item?.currentAmount}
                            subscriptionDetailCardType={subscriptionDetailCardType}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}